<template>
  <v-dialog
    v-model="isModalOpen"
    :width="width"
    :overlay-color="overlayColor"
    :persistent="persistent"
    :no-click-animation="true"
  >
    <div class="modal-content">
      <div
        v-if="isShowClose"
        class="modal-content-close"
        @click="isModalOpen = false"
      >
        ×
      </div>
      <slot />
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '330'
    },
    overlayColor: {
      type: String,
      default: undefined
    },
    persistent: {
      type: Boolean,
      default: false
    },
    isShowClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isModalOpen: {
      get() {
        return this.isOpen
      },
      set(val) {
        this.$emit('update:isOpen', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modal-content {
  background-color: white;
  border: 1px solid rgb(237, 237, 237);
  border-radius: 8px;
  position: relative;

  &-close {
    position: absolute;
    cursor: pointer;
    right: 16px;
    top: 4px;
    font-size: 28px;
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
